export class Message {
  memberIds: number[] = []
  subject: string = ''
  body: string = ''
  emailNotification: boolean = false
  pushNotification: boolean = false

  constructor (attributes?) {
    Object.assign(this, attributes)
  }

}
